import { useMutation, useQueryClient } from '@tanstack/react-query';

import { putPromotion } from '@arrived/api_v2';
import { Rewards } from '@arrived/models';

import { UseMutationOptions } from '../queries.utils';
import { promotionKeyFn, promotionsKeyFn } from './rewards.keys';

export function usePutPromotionMutation(
  options?: UseMutationOptions<Rewards.Promotion, Rewards.PromotionUpdateRequest & { uuid: string }>
) {
  const queryClient = useQueryClient();

  return useMutation(
    (promotionUpdateRequestWithUuid) => {
      const { uuid, ...rest } = promotionUpdateRequestWithUuid;
      return putPromotion(uuid, rest);
    },
    {
      ...options,
      onSuccess: (data, variables, context) => {
        const { uuid } = data;

        queryClient.setQueryData(promotionKeyFn(uuid), data);

        queryClient.invalidateQueries(promotionsKeyFn());

        options?.onSuccess?.(data, variables, context);
      },
    }
  );
}
